const clientId: string = window.ChocoClientId || import.meta.env.VITE_CLIENT_ID;

export { clientId as CLIENT_ID };
